import React from 'react'

// Translations
import { TRANSLATIONS } from 'pages/BusinessHome/utilities';
import { getTranslation } from 'translations';

// Components
import Button from 'components/Button/Button';

// Styles
import styles from './ForClients.module.scss'

const ForClients = () => {
    
    const LANG = document.documentElement.lang.substring(0, 2)

    const GET_A_QUOTE_LINK = `https://filotrack.com/${LANG === "it" ? "it" : "en"}/business/b2b-2022-llp-gadget-eventi-search/?utm_source=new-site&utm_medium=redirect&utm_campaign=redirect_b2c_to-b2b`

    function goGetAQuote() {
      window.location.href = GET_A_QUOTE_LINK;
      return false;
    }

  return (
    <div className={styles["for-clients"]}>
        <div className={styles["content-container"]}>
            <h2 className={styles['title']}>{getTranslation(TRANSLATIONS, LANG, "clients_section_title")}</h2>
            <p className={styles["subtitle"]}>{getTranslation(TRANSLATIONS, LANG, "clients_section_subtitle")}</p>
            <Button 
              variant="secondary"
              handlers={{onClick: goGetAQuote}}
            >{getTranslation(TRANSLATIONS, LANG, "clients_section_button")}</Button>
        </div>
        <img src="https://filotrack.com/wp-content/uploads/Business_4Clients_1.png" alt="" className={styles["section-img"]} />
    </div>
  )
}

export default ForClients